export function initials(input: string): string {
    const cleaned = input.trim();
    if (!cleaned) return "";
    const parts = cleaned.split(/\s+/);
    if (parts.length >= 2) {
        return `${parts[0]!.charAt(0)}${parts[1]!.charAt(0)}`.toUpperCase();
    }
    return cleaned.slice(0, 2).toUpperCase();
}
